/* eslint-disable */

<template>
  <div>
    <div class="vx-row">

      <div class="vx-col lg:w-4/12 md:w-5/12 sm:w-5/5 mb-4">
        <div class="flex gap-2 mb-2">
          <vs-button :color="sel==='r1'?'primary':'grey'" type="filled" class="flex-1" @click="sel='r1'">R1</vs-button>
          <vs-button :color="sel==='r2'?'primary':'grey'" type="filled" class="flex-1" @click="sel='r2'">R2</vs-button>
        </div>

        <vx-card style="height: 42rem; overflow-y: auto">

          <!-- Task 1 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task1Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task1Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task1Done?'#28C76F':'#4a5568'}">1</span>
              <span class="font-semibold text-sm flex-1">Default route on R2 → ISP</span>
              <span class="text-xs font-medium" :class="task1Done?'text-success':'text-grey'">{{ task1Done?1:0 }}/1</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">R2</span>
              <div class="space-y-1 ml-1">
                <div v-for="item in task1Items" :key="'t1-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r2Completion[item.key])"></div>
                  <code class="text-base" :class="r2Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
            </div>
          </div>

          <!-- Task 2 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task2Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task2Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task2Done?'#28C76F':'#4a5568'}">2</span>
              <span class="font-semibold text-sm flex-1">Default route on R1 → R2 (find E0/0 IP first)</span>
              <span class="text-xs font-medium" :class="task2Done?'text-success':'text-grey'">{{ task2Progress }}/2</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">R2 — discovery</span>
              <div class="space-y-1 ml-1 mb-2">
                <div v-for="item in task2R2Items" :key="'t2r2-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r2Completion[item.key])"></div>
                  <code class="text-base" :class="r2Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">R1</span>
              <div class="space-y-1 ml-1">
                <div v-for="item in task2R1Items" :key="'t2r1-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r1Completion[item.key])"></div>
                  <code class="text-base" :class="r1Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
            </div>
          </div>

          <!-- Task 3 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task3Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task3Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task3Done?'#28C76F':'#4a5568'}">3</span>
              <span class="font-semibold text-sm flex-1">Host route on R2 → server 10.0.41.10 (via e0/1)</span>
              <span class="text-xs font-medium" :class="task3Done?'text-success':'text-grey'">{{ task3Done?1:0 }}/1</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">R2</span>
              <div class="space-y-1 ml-1">
                <div v-for="item in task3Items" :key="'t3-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r2Completion[item.key])"></div>
                  <code class="text-base" :class="r2Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
            </div>
          </div>

          <!-- Task 4 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task4Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task4Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task4Done?'#28C76F':'#4a5568'}">4</span>
              <span class="font-semibold text-sm flex-1">LAN route on R1 → 10.0.41.0/24 (via e0/1)</span>
              <span class="text-xs font-medium" :class="task4Done?'text-success':'text-grey'">{{ task4Done?1:0 }}/1</span>
            </div>
            <div class="px-3 py-2">
              <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">R1</span>
              <div class="space-y-1 ml-1">
                <div v-for="item in task4Items" :key="'t4-'+item.key" class="flex items-center gap-2">
                  <div class="flex-shrink-0 rounded-full" :style="dot(r1Completion[item.key])"></div>
                  <code class="text-base" :class="r1Completion[item.key]?'text-success':''">{{ item.label }}</code>
                </div>
              </div>
            </div>
          </div>

          <!-- Save -->
          <div class="rounded-lg mb-2 overflow-hidden" :style="{border:'1px solid '+(saveDone?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:saveDone?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <feather-icon :icon="saveDone?'CheckCircleIcon':'CircleIcon'" :svgClasses="saveDone?'text-success':'text-grey'" size="16" class="flex-shrink-0" />
              <span class="font-semibold text-sm flex-1">Save Configuration</span>
              <span class="text-xs font-medium" :class="saveDone?'text-success':'text-grey'">{{ [r1Completion.saved,r2Completion.saved].filter(Boolean).length }}/2</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="rk in ['r1','r2']" :key="'s-'+rk" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ rk.toUpperCase() }}</span>
                <div class="space-y-1 ml-1">
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="dot(getComp(rk).saved)"></div>
                    <code class="text-base" :class="getComp(rk).saved?'text-success':''">copy running-config startup-config</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </vx-card>
      </div>

      <div class="vx-col lg:w-8/12 md:w-7/12 sm:w-5/5">
        <div style="height: 35rem">
          <vue-command v-show="sel==='r1'" key="r1" id="r1_terminal" :commands="r1Commands" :prompt="r1Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="R1" />
          <vue-command v-show="sel==='r2'" key="r2" id="r2_terminal" :commands="r2Commands" :prompt="r2Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="R2" />
        </div>

        <!-- Topology -->
        <div class="topology-card">
          <img :src="topologyImage" alt="Network topology" class="topology-img" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VueCommand, { createStdout, createStderr } from 'vue-command';
import 'vue-command/dist/vue-command.css';

const HELP = 'Type commands as shown in the task checklist. Use "show ip interface brief" on R2 to find E0/0\'s IP for Task 2.';

const mkCommands = (rk, vm) => ({
  help:      () => createStdout(HELP),
  enable:    () => vm.iosEnable(rk),
  configure: (x) => vm.iosConfigure(rk, x),
  conf:      (x) => vm.iosConfigure(rk, x),
  ip:        (x) => vm.iosIp(rk, x),
  show:      (x) => vm.iosShow(rk, x),
  exit:      () => vm.iosExit(rk),
  end:       () => vm.iosEnd(rk),
  copy:      (x) => vm.iosCopy(rk, x),
});

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      topologyImage: 'https://ip-learn.b-cdn.net/simulations/ccna-topologies/Static_Routing_Configuration_Sim_6.png',
      sel: 'r2',
      totalScore: 0,

      r1: { mode: 'exec' },
      r2: { mode: 'exec' },

      // r1(3) + r2(4) = 7 total keys
      r1Completion: { defaultRoute: false, lanRoute: false, saved: false },
      r2Completion: { defaultRoute: false, showIpBrief: false, serverRoute: false, saved: false },

      r1Commands: null,
      r2Commands: null,

      task1Items:  [{ key: 'defaultRoute', label: 'ip route 0.0.0.0 0.0.0.0 209.165.200.225' }],
      task2R2Items:[{ key: 'showIpBrief',  label: 'show ip interface brief' }],
      task2R1Items:[{ key: 'defaultRoute', label: 'ip route 0.0.0.0 0.0.0.0 10.0.12.2' }],
      task3Items:  [{ key: 'serverRoute',  label: 'ip route 10.0.41.10 255.255.255.255 e0/1' }],
      task4Items:  [{ key: 'lanRoute',     label: 'ip route 10.0.41.0 255.255.255.0 e0/1' }],
    };
  },

  computed: {
    r1Prompt() { const m=this.r1.mode; return m==='config'?'R1(config)#':'R1#'; },
    r2Prompt() { const m=this.r2.mode; return m==='config'?'R2(config)#':'R2#'; },

    task1Done()     { return !!this.r2Completion.defaultRoute; },
    task2Progress() { return [this.r2Completion.showIpBrief, this.r1Completion.defaultRoute].filter(Boolean).length; },
    task2Done()     { return this.task2Progress === 2; },
    task3Done()     { return !!this.r2Completion.serverRoute; },
    task4Done()     { return !!this.r1Completion.lanRoute; },
    saveDone()      { return this.r1Completion.saved && this.r2Completion.saved; },
  },

  mounted() {
    this.dataLocal.options.showMarkButton = false;
    this.$emit('simulation_update_options', this.dataLocal);
    this.r1Commands = mkCommands('r1', this);
    this.r2Commands = mkCommands('r2', this);
  },

  methods: {
    getComp(k) { return this[k + 'Completion']; },

    dot(val) {
      return { width:'8px', height:'8px', background: val?'#28C76F':'transparent', border:'2px solid '+(val?'#28C76F':'#6b7280') };
    },

    guide(msg) {
      return `<span style="color:#28C76F;display:block;margin-top:6px;padding:4px 8px;border-left:2px solid #28C76F;font-size:0.85em;line-height:1.5">${msg}</span>`;
    },

    normalizeIf(ifStr) {
      return (ifStr || '').toLowerCase()
        .replace(/^gigabitethernet/,'').replace(/^fastethernet/,'').replace(/^ethernet/,'')
        .replace(/^gi(?=\d)/,'').replace(/^fa(?=\d)/,'').replace(/^e(?=\d)/,'').replace(/^g(?=\d)/,'')
        .trim();
    },

    updateScore() {
      const score = Object.values(this.r1Completion).filter(Boolean).length +
                    Object.values(this.r2Completion).filter(Boolean).length;
      this.totalScore = score;
      this.$forceUpdate();
      this.$emit('simulation_update_score', score);
      if (score >= 7) setTimeout(() => this.$emit('simulation_full_correct', score), 500);
    },

    iosEnable(rk) { this[rk].mode = 'exec'; return createStdout(''); },

    iosConfigure(rk, x) {
      if (this[rk].mode !== 'exec') return createStderr('% Already in configuration mode — type "end" to return to exec first');
      if (x._[1] === 'terminal' || x._[1] === 't') {
        this[rk].mode = 'config';
        return createStdout('Enter configuration commands, one per line.  End with CNTL/Z.');
      }
      return createStderr('% Invalid input detected');
    },

    iosExit(rk) {
      if (this[rk].mode === 'config') this[rk].mode = 'exec';
      return createStdout('');
    },

    iosEnd(rk) { this[rk].mode = 'exec'; return createStdout(''); },

    iosIp(rk, x) {
      const s = this[rk];
      if ((x._[1] || '').toLowerCase() !== 'route') return createStderr('% Invalid input detected');
      if (s.mode !== 'config') return createStderr('% Must be in global configuration mode');

      const dest = String(x._[2] || '');
      const mask = String(x._[3] || '');
      const arg4 = String(x._[4] || '');  // next-hop IP or exit interface
      const c    = this[rk + 'Completion'];
      // Normalize arg4 to detect interface references
      const ifNorm = this.normalizeIf(arg4);

      // Task 1 — R2 default route to ISP
      if (rk === 'r2' && dest === '0.0.0.0' && mask === '0.0.0.0' && arg4 === '209.165.200.225' && !c.defaultRoute) {
        c.defaultRoute = true; this.updateScore();
        return createStdout(this.guide(
          'Default route configured on R2 to the ISP (209.165.200.225). 0.0.0.0/0 matches all destinations with no more specific entry — R2\'s gateway of last resort is now the ISP. ' +
          '→ Configure Task 2: run "show ip interface brief" on R2 to find E0/0\'s IP, then set R1\'s default route.'
        ));
      }

      // Task 2 — R1 default route via R2
      if (rk === 'r1' && dest === '0.0.0.0' && mask === '0.0.0.0' && arg4 === '10.0.12.2' && !c.defaultRoute) {
        c.defaultRoute = true; this.updateScore();
        return createStdout(this.guide(
          'Default route configured on R1 via 10.0.12.2 (R2 E0/0). Traffic from R1 with no specific destination is forwarded to R2, which forwards to the ISP. ' +
          '→ Configure Task 3: host route on R2 for the server — "ip route 10.0.41.10 255.255.255.255 e0/1".'
        ));
      }

      // Task 3 — R2 host route to server using exit interface
      if (rk === 'r2' && dest === '10.0.41.10' && mask === '255.255.255.255' && ifNorm === '0/1' && !c.serverRoute) {
        c.serverRoute = true; this.updateScore();
        return createStdout(this.guide(
          'Host route (/32) to server 10.0.41.10 configured on R2 using exit interface e0/1 instead of a next-hop IP. ' +
          'Using exit interface avoids needing to know R4\'s IP — packets to 10.0.41.10 exit via e0/1. ' +
          'Note: on multi-access Ethernet, this triggers proxy-ARP for each destination; for point-to-point links it works cleanly. ' +
          '→ Configure Task 4: LAN route on R1 — "ip route 10.0.41.0 255.255.255.0 e0/1".'
        ));
      }

      // Task 4 — R1 LAN route using exit interface
      if (rk === 'r1' && dest === '10.0.41.0' && mask === '255.255.255.0' && ifNorm === '0/1' && !c.lanRoute) {
        c.lanRoute = true; this.updateScore();
        return createStdout(this.guide(
          'Static route to LAN 10.0.41.0/24 configured on R1 via exit interface e0/1 (toward R3). ' +
          'Since R3 is inaccessible for direct configuration, using the exit interface is a practical workaround — the router forwards matching packets out e0/1 and relies on connected devices to reach the LAN. ' +
          '→ Save both routers: "end" then "copy running-config startup-config".'
        ));
      }

      return createStdout('');
    },

    iosShow(rk, x) {
      const sub1 = (x._[1] || '').toLowerCase();
      const sub2 = (x._[2] || '').toLowerCase();
      const sub3 = (x._[3] || '').toLowerCase();

      if (sub1 === 'ip' && sub2 === 'interface' && sub3 === 'brief') {
        if (rk === 'r2') {
          const c = this.r2Completion;
          if (!c.showIpBrief) { c.showIpBrief = true; this.updateScore(); }
          return createStdout(
            'Interface&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;IP-Address&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;OK?&nbsp;Method&nbsp;Status&nbsp;&nbsp;&nbsp;&nbsp;Protocol<br>' +
            'Ethernet0/0&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10.0.12.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;YES&nbsp;NVRAM&nbsp;&nbsp;up&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;up<br>' +
            'Ethernet0/1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10.0.24.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;YES&nbsp;NVRAM&nbsp;&nbsp;up&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;up<br>' +
            'Ethernet0/2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;209.165.200.226&nbsp;&nbsp;YES&nbsp;NVRAM&nbsp;&nbsp;up&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;up<br>' +
            'Ethernet0/3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;unassigned&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;YES&nbsp;NVRAM&nbsp;&nbsp;up&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;up' +
            this.guide(
              'E0/0 IP is 10.0.12.2 — this is R2\'s interface connecting to R1. ' +
              '→ Switch to R1 and configure: "ip route 0.0.0.0 0.0.0.0 10.0.12.2".'
            )
          );
        }
        // R1 interface table (informational)
        return createStdout(
          'Interface&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;IP-Address&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;OK?&nbsp;Method&nbsp;Status&nbsp;&nbsp;&nbsp;&nbsp;Protocol<br>' +
          'Ethernet0/0&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10.0.12.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;YES&nbsp;NVRAM&nbsp;&nbsp;up&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;up<br>' +
          'Ethernet0/1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10.0.13.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;YES&nbsp;NVRAM&nbsp;&nbsp;up&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;up'
        );
      }

      return createStderr('% Invalid input detected');
    },

    iosCopy(rk, x) {
      if (this[rk].mode !== 'exec') return createStderr('% Must be in privileged EXEC mode — type "end" first');
      const c = this[rk + 'Completion'];
      if (x._[1] === 'running-config' && x._[2] === 'startup-config') {
        if (!c.saved) { c.saved = true; this.updateScore(); }
        return createStdout('Destination filename [startup-config]?<br>Building configuration...<br>[OK]' +
          this.guide(`${rk.toUpperCase()} configuration saved. ` + (this.saveDone ? '✓ Both routers saved — simulation complete!' : '→ Save the remaining router.')));
      }
      return createStderr('% Invalid input detected');
    },
  },

  components: { VueCommand },
  props: { data: { type: Object, required: true } },
};
</script>

<style>
#r1_terminal, #r2_terminal { overflow: hidden !important; }

.topology-card {
  margin-top: 1.5rem;
  background-color: #111111;
  border: 1px solid #181d2a;
  border-radius: 0.5rem;
  overflow: hidden;
  line-height: 0;
}
.topology-img {
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
}
</style>

